var ReoAuthSDK = /** @class */ (function () {
    function ReoAuthSDK(domain) {
        this.REO_SESS_AUTH_CODE = 'REO_SESS_AUTH_CODE';
        this.REO_ONLINE_SIGN = 'REO_ONLINE_SIGN';
        if (domain) {
            this.domain = domain;
        }
        else {
            console.error('did not receive domain parameter');
            this.domain = '';
        }
    }
    ReoAuthSDK.prototype.getCookie = function (name) {
        var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
        if (arr = document.cookie.match(reg)) {
            return unescape(arr[2]);
        }
        else {
            return null;
        }
    };
    ReoAuthSDK.prototype.hasCookie = function (name) {
        if (document.cookie.indexOf(name + "=") === -1) {
            return false;
        }
        else {
            return true;
        }
    };
    ReoAuthSDK.prototype.removeCookie = function (name, domain, path) {
        if (path === void 0) { path = '/'; }
        if (!name) {
            return false;
        }
        else if (!this.hasCookie(name)) {
            console.warn("cannot find cookie named: " + name);
            return false;
        }
        else {
            if (domain) {
                document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT;domain=" + domain + "; path=" + path + ";secure;";
            }
            else {
                document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT;path=" + path + "; secure;";
            }
            return true;
        }
    };
    ReoAuthSDK.prototype.setCookie = function (name, value, expires, path) {
        if (path === void 0) { path = '/'; }
        var expireTime = 'Thu, 01 Jan 1970 00:00:00 GMT';
        if (typeof expires === 'number') {
            expireTime = new Date(expires * 1000 + new Date().getTime()).toUTCString();
        }
        else if (typeof expires === 'string') {
            var num = parseInt(expires, 10);
            expireTime = new Date(num * 1000 + new Date().getTime()).toUTCString();
        }
        else {
            console.error("wrong cookie expires type of: " + typeof expires + "!");
            return false;
        }
        document.cookie = name + "=" + value + "; expires=" + expireTime + "; path=" + path + "; domain=" + this.domain;
        return true;
    };
    ReoAuthSDK.prototype.setAuthCookie = function (value, expires) {
        return this.setCookie(this.REO_SESS_AUTH_CODE, value, expires);
    };
    ReoAuthSDK.prototype.getAuthCookie = function () {
        return this.getCookie(this.REO_SESS_AUTH_CODE);
    };
    ReoAuthSDK.prototype.removeAuthCookie = function () {
        return this.removeCookie(this.REO_SESS_AUTH_CODE, this.domain);
    };
    ReoAuthSDK.prototype.setOnlineCookie = function (value, expires) {
        return this.setCookie(this.REO_ONLINE_SIGN, value, expires);
    };
    ReoAuthSDK.prototype.getOnlineCookie = function () {
        return this.getCookie(this.REO_ONLINE_SIGN);
    };
    ReoAuthSDK.prototype.removeOnlineCookie = function () {
        return this.removeCookie(this.REO_ONLINE_SIGN, this.domain);
    };
    return ReoAuthSDK;
}());
export default ReoAuthSDK;
//# sourceMappingURL=reoAuthSDK.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reolink/reo-auth-sdk/dist/reoAuthSDK.js
// module id = null
// module chunks = 